
export default function Footer() {


    return (
        <div className="row">
            <div className="col-4"> </div>
            <div className="col-4">
                <a href="https://www.qhseinternational.com/privacy-policy/" target="_blanck">Privacy</a>
                 <a href="https://www.qhseinternational.com/contact/" target="_blanck">| Contact Us</a>
                 <br />
               ©Qhseinternational.com All Rights Reserved </div>
            <div className="col-4"> </div>
        </div>
    );
}


